


































import { Component, Prop, Vue } from "vue-property-decorator";
import ImplementasiTable from "./ImplementasiTable.vue";

@Component({
  components: {
    ImplementasiTable
  }
})
export default class ImplementasiModal extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop({ type: Boolean, default: false }) readonly: boolean;
  @Prop({ type: Array, default: () => [] }) implementationList!: any[];
  @Prop({ type: Object, default: null }) deletingItem!: number | null;

  get dialog(): boolean {
    return this.value;
  }

  set dialog(value: boolean) {
    this.$emit("input", value);
  }
}
